import { ListGroup } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';

const CourseChapters = ({ item, courseID }) => {
  let { course } = useParams()
  localStorage.setItem('course', JSON.stringify(course))


  return (
    <ListGroup.Item>
      <Link to={`/courses/${courseID}/chapters/${item?.id}`}>
        <div className="flex items-center justify-between my-2">
          <h6 className='m-0 fw-bold pe-3'>{item?.title}</h6>
          <div className="w-6 h-6">
            <img src={require('../../assets/arrow-detail-icon-2x.png')} alt='arrow-detail-icon' className='w-full h-full' />
          </div>

        </div>
      </Link>
    </ListGroup.Item>
  )
}

export default CourseChapters